module.exports = __webpack_public_path__ + "img/education-quiz-icon.8c728fa3.jpg";